import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { TimeLine } from "./TimeLine/TimeLine";
import { SLAIndicator } from "./SLAIndicator/SLAIndicator";
import { Box, Grid2 } from "@mui/material";
import { Confirmation } from "../../../Modal/Confirmation/Confirmation";
import { DescriptionStatus } from "./DescriptionStatus/DescriptionStatus";
import { CommentsAndStatus } from "./CommentsAndStatus/CommentsAndStatus";
import { Historical } from "./Historical/Historical";
import { ActionsAndResolutions } from "./ActionsAndResolutions/ActionsAndResolutions";
import "./Care.scss";

export const Care = ({
  reportDetail,
  reportRender,
  setActiveTab,
  investigationList,
  offenders,
  victims,
}) => {
  // -----> Custom Hooks <----- //
  const { id } = useParams();
  const { userInfo } = useSelector((state) => state.auth);
  const statuses = userInfo?.policy?.deny?.status ?? [];

  // -----> Initial State <----- //
  // Current report status
  const [currentReportStatus, setCurrentReportStatus] = useState(
    reportDetail?.status?.current
  );

  // Report status preselected
  const [status, setStatus] = useState(reportDetail?.status?.current || "");
  // Loading
  const [isLoading, setIsLoading] = useState(false);
  // Show modal confirmation
  const [modalConfirm, setModalConfirm] = useState({
    show: false,
    variant: "",
    title: "",
    titleColor: "",
    description1: "",
    description2: "",
    question: "",
    loading: false,
    // Left Button
    leftButtonText: "",
    leftButtonColor: "",
    leftButtonVariant: "contained",
    leftButtonLabelColor: "",
    leftIconName: "",
    leftIconColor: "",
    leftIconColorHover: "",
    onClickLeft: () => {},
    // Rigth Button
    rightButtonText: "",
    rightButtonColor: "",
    rightButtonVariant: "contained",
    rightButtonLabelColor: "",
    rightIconName: "",
    rightIconColor: "",
    rightIconColorHover: "",
    onClickRight: () => {},
    ethiquin: "",
    hasInvDescription: false,
  });
  // Task Reliazation
  const [checkboxes, setCheckboxes] = useState([]);

  const [allChecked, setAllChecked] = useState(false);

  // Update status when report change
  useEffect(() => {
    setCurrentReportStatus(reportDetail?.status?.current);
    setStatus(reportDetail?.status?.current);
  }, [reportDetail?.id]);

  // initialize status
  useEffect(() => {
    if (
      reportDetail?.status?.current === "closed" &&
      !reportDetail?.status?.details
    ) {
      setStatus("closing_process");
    } else {
      setStatus(reportDetail?.status?.current || "");
    }
  }, [reportDetail?.status?.details]);

  // To Navigate between report statuses
  const interstateNavigation = (state) => {
    setCurrentReportStatus(state);
    setActiveTab("Status de atención");
  };

  // Open the confirmation modal with the information to be rendered
  const openModalConfirm = ({
    //key = // value by defualt
    variant = "light",
    title = "",
    titleColor = "secondary",
    description1 = "",
    description2 = "",
    question = "",
    loading = false,
    leftButtonText = "Cancel",
    leftButtonColor = "secondary",
    leftButtonVariant = "contained",
    leftButtonLabelColor = "",
    leftIconName = "",
    leftIconColor = "",
    leftIconColorHover = "",
    onClickLeft = () => {},
    rightButtonText = "Confirm",
    rightButtonColor = "primary",
    rightButtonVariant = "contained",
    rightButtonLabelColor = "",
    rightIconName = "",
    rightIconColor = "",
    rightIconColorHover = "",
    onClickRight = () => {},
    ethiquin = "",
    inputLabel = "",
    hasInvDescription = false,
  }) => {
    setModalConfirm({
      show: true,
      variant,
      title,
      titleColor,
      description1,
      description2,
      question,
      loading,
      leftButtonText,
      leftButtonColor,
      leftButtonVariant,
      leftButtonLabelColor,
      leftIconName,
      leftIconColor,
      leftIconColorHover,
      onClickLeft,
      rightButtonText,
      rightButtonColor,
      rightButtonVariant,
      rightButtonLabelColor,
      rightIconName,
      rightIconColor,
      rightIconColorHover,
      onClickRight,
      ethiquin,
      inputLabel,
      hasInvDescription,
    });
  };
  // Close confirmation modal
  const closeModalConfirm = () => {
    setModalConfirm((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  return (
    <>
      {/* Modal Confirmation */}
      <Confirmation
        {...modalConfirm}
        onHide={closeModalConfirm}
        loading={isLoading}
      />

      <Box className="mt-3 p-4 dyTheme1 dyBorder1 rounded care">
        <TimeLine
          reportDetail={reportDetail}
          interstateNavigation={interstateNavigation}
        />
        {/* Current description status */}
        <DescriptionStatus
          currentReportStatus={currentReportStatus}
          reportDetail={reportDetail}
          allChecked={allChecked}
          setAllChecked={setAllChecked}
          checkboxes={checkboxes}
          setCheckboxes={setCheckboxes}
          reportRender={reportRender}
          statuses={statuses}
          status={status}
        />
        {/* SLA Compliance Indicator */}
        <SLAIndicator reportDetail={reportDetail} />

        <Grid2
          container
          spacing={3}
          py={2}
          justifyContent="center"
          alignItems="flex-start"
        >
          <Grid2 size={{ xs: 12, sm: 8 }}>
            {/* General Status Report Comment */}
            <CommentsAndStatus
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              id={id}
              status={status}
              setStatus={setStatus}
              openModalConfirm={openModalConfirm}
              closeModalConfirm={closeModalConfirm}
              interstateNavigation={interstateNavigation}
              statuses={statuses}
              reportRender={reportRender}
              reportDetail={reportDetail}
              currentReportStatus={currentReportStatus}
              selectAllTask={allChecked}
              checkboxes={checkboxes}
              setActiveTab={setActiveTab}
            />
            {/* Resolution & Actions and Sanctions */}
            {currentReportStatus === "finish" && (
              <ActionsAndResolutions
                victims={victims}
                offenders={offenders}
                reportDetail={reportDetail}
                reportRender={reportRender}
                investigationList={investigationList}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                setActiveTab={setActiveTab}
              />
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 4 }}>
            <Historical history={reportDetail?.status?.history || []} />
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};
